/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Collaboration
 * (C) Copyright IBM Corp. 2018
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define('collaboration/canvaseditor/shapes/CropShape',['underscore', './Shape', 'fabric'], function (_, Shape) {
	'use strict';

	var Crop = window.fabric.util.createClass(window.fabric.Object, {

		type: 'crop',

		_render: function _render(ctx) {
			void ctx;
			// Nothing here
		},

		drawBorders: function drawBorders(ctx, styleOverride) {
			void styleOverride;
			var cropW = this.width,
			    cropH = this.height,
			    x = -cropW / 2,
			    y = -cropH / 2,
			    left = this.left,
			    top = this.top,
			    canvasW = this.canvas.getWidth(),
			    canvasH = this.canvas.getHeight();

			ctx.save();
			ctx.fillStyle = 'rgba(0, 0, 0, 0.7)';
			ctx.fillRect(x - left, y - top, canvasW, top);
			ctx.fillRect(x - left, y, left, cropH);
			ctx.fillRect(x + cropW, y, canvasW - cropW - left, cropH);
			ctx.fillRect(x - left, y + cropH, canvasW, canvasH - cropH - top);
			ctx.restore();
		}
	});

	var CropShape = Shape.extend({

		/**
   * Called by constructor.
   * @param options {Object} Options
   */
		init: function init(options) {
			CropShape.inherited('init', this, arguments);

			this.originalX = options.xCoord;
			this.originalY = options.yCoord;
			this.shape = new Crop(_.extend({
				left: options.xCoord,
				top: options.yCoord,
				originX: 'left',
				originY: 'top',
				width: 0,
				height: 0,
				angle: 0,
				stroke: 'transparent',
				fill: 'transparent',
				selectable: true,
				figure: 'crop'
			}, this.defaultAttributes));
			options.canvas.add(this.shape);
		},

		getDimensions: function getDimensions() {
			return {
				top: this.shape.top,
				left: this.shape.left,
				width: this.shape.width,
				height: this.shape.height
			};
		},

		resize: function resize(xCoord, yCoord) {
			var newProps = {
				width: this.originalX - xCoord === 0 ? this.defaultWidth : Math.abs(this.originalX - xCoord),
				height: this.originalY - yCoord === 0 ? this.defaultHeight : Math.abs(this.originalY - yCoord)
			};
			if (this.originalX > xCoord) {
				newProps.left = Math.abs(xCoord);
			}
			if (this.originalY > yCoord) {
				newProps.top = Math.abs(yCoord);
			}
			this.shape.set(newProps);
			return this.shape;
		},

		finish: function finish(event, canvas) {
			// eslint-disable-line no-unused-vars
			this.shape.setCoords();
		},

		reset: function reset() {
			if (this.shape && this.shape.canvas) {
				this.shape.canvas.remove(this.shape);
			}
		}
	});

	CropShape.drawControlsVisibility = function (canvas, shape) {
		canvas.setActiveObject(shape);
		shape.setControlsVisibility({
			mtr: false,
			mb: true,
			mt: true,
			ml: true,
			mr: true,
			tl: true,
			br: true,
			tr: true,
			bl: true
		});
	};

	CropShape.scale = function (shape) {
		var newWidth = shape.width * shape.scaleX;
		var newHeight = shape.height * shape.scaleY;
		shape.set({
			'width': newWidth,
			'height': newHeight
		});
		shape.scale(1);
	};

	CropShape.canUpdate = function () {
		return false;
	};

	CropShape.canSkew = function () {
		return false;
	};

	CropShape.handleEnterKeyEvent = function (shape) {}; // eslint-disable-line no-unused-vars

	return CropShape;
});
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}
}();

;

